import { useQuery } from "@tanstack/react-query";
import { normalizarFecha } from "../utils/dateUtils";
import { get } from "./divertidogsApiUtils";

export interface ItemListadoMascotasReservas {
  id: string;
  nombre: string;
  idPropietario: string;
  nombresPropietario: string;
  documentoPropietario: string;
  raza: string;
  fechasReservadas: Date[];
}

// Lista las mascotas con las fechas reservadas de hotel.
export const listarMascotasReservasHotel = async (): Promise<
  ItemListadoMascotasReservas[] | undefined
> => {
  const resp = await get<Array<ItemListadoMascotasReservas>>(
    "reservas/hotel/mascotas"
  );
  return resp?.map((item) => {
    return {
      ...item,
      fechasReservadas: item.fechasReservadas.map((fecha) =>
        normalizarFecha(fecha)
      ),
    };
  });
};

const QUERY_LISTAR_MASCOTAS_RESERVAS_HOTEL =
  "QUERY_LISTAR_MASCOTAS_RESERVAS_HOTEL";

export const useListarMascotasReservasHotel = () => {
  return useQuery(
    [QUERY_LISTAR_MASCOTAS_RESERVAS_HOTEL],
    async () => await listarMascotasReservasHotel()
  );
};

